import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Hidden,
  Button,
} from '@mui/material';

import { logout } from "../utils/auth"

import helpIcon from "../images/helpIcon.svg"
import accountIcon from "../images/accountIcon.svg"
import logOutIcon from "../images/logOutIcon.svg"
import bigLogOutIcon from "../images/bigLogOutIcon.svg"
import closeIcon from '../images/closeIcon.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import chevronDownIcon from '../images/chevronDownIcon.svg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import LanguageContext from "../contexts/LanguageContext"
import { useTexte } from "../contexts/FormeAdresseContext"

import MyMiniModal from "./ui/MyMiniModal"
import MyModal from "./ui/MyModal"
import MyAccount from "./ui/MyAccount"


const GlobalMenu = ({ globalMenu, setGlobalMenu, globalMenuRef, updateUserContext, currentUser }) => {
  const navigate = useNavigate();

  const [actUser, setActUser] = useState(null)

  useEffect(() => {
    setActUser(currentUser)
  }, [currentUser])

  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement (07/10/2026) : selon la cible du module en cours
     chez l'apprenant. Ce menu sert aussi l'espace client et l'admin, ou le
     contexte de forme n'est pas pose : ils restent au vous, inchanges. */
  const t = useTexte()

  const [logoutModal, setLogOutModal] = useState(false)
  const [accountModal, setAccountModal] = useState(false)
  const [myAccountPage, setMyAccountPage] = useState("select")


  useEffect(() => {
    if (accountModal === false) {
      setTimeout(() => {
        setMyAccountPage("select")
      }, 500)
    }
  }, [accountModal])


  return (
    <>
      {/* GLOBAL MENU */ }
      {actUser &&
        <Box ref={globalMenuRef} sx={{
          display:"flex",
          alignItems:"center",
          gap:"7px",
          height:"100%"
        }}>
          <Button
            disableRipple
            onClick={() => { setGlobalMenu(!globalMenu) }}
            sx={{
              fontSize:"15px",
              color:"text.secondary",
              "& .MuiButton-endIcon" : {
                marginLeft:"4px !important",
              },
              "&:hover" : {
                background:"transparent",
                color:"rgba(0,0,0,0.75)"
              }
            }}
            size="small"
            endIcon={<img src={chevronDownIcon} style={{width:"14px", transform:globalMenu === true ? "rotate(180deg)" : "none", transition:"transform .15s"}} alt=""/>} // L26
          >
            <AccountCircleIcon sx={{width:"30px", height:"30px",}}/>
            <Hidden lgDown>
              <Box sx={{fontSize:"15px", marginLeft:"8px", lineHeight:"normal"}}>{actUser?.name}</Box>
            </Hidden>
          </Button>
          {globalMenu === true &&
            <Box  sx={{
              position:"absolute",
              width:"200px",
              background:"white",
              top:["65px","75px"],
              right:"20px",
              border:"1px solid black",
              boxShadow: "0px 1px 20px rgba(0, 0, 0, 0.1)",
              userSelect:"none",
            }}>
              <Box
                onClick={() => {
                  // L27 : simple mailto pour le moment
                  window.location.href = "mailto:support@risinguparis.com"
                  setGlobalMenu(false)
                }}
                sx={{
                  height:"50px",
                  padding:"15px 20px",
                  lineHeight:"20px",
                  fontSize:"16px",
                  color:"text.blackTitle",
                  cursor:"pointer",
                  display:"flex",
                  gap:"10px",
                  "&:hover" : {
                    backgroundColor:"background.grey",
                  }
                }}
              >
                <img src={helpIcon} style={{height:"20px", width:"20px"}}/>
                {languageValues?.globalMenu?.help[actLanguage]}
              </Box>
              <Box
                onClick={() => {
                  setAccountModal(true)
                  setGlobalMenu(false)
                }}
                sx={{
                  height:"50px",
                  padding:"15px 20px",
                  lineHeight:"20px",
                  fontSize:"16px",
                  color:"text.blackTitle",
                  cursor:"pointer",
                  display:"flex",
                  gap:"10px",
                  "&:hover" : {
                    backgroundColor:"background.grey",
                  }
                }}
              >
                <img src={accountIcon} style={{height:"20px", width:"20px"}}/>
                {languageValues?.globalMenu?.account[actLanguage]}
              </Box>
              {actUser?.isAdmin === true &&
                <Box
                  onClick={() => {
                    navigate("/admin")
                    setGlobalMenu(false)
                  }}
                  sx={{
                    height:"50px",
                    padding:"15px 20px",
                    lineHeight:"20px",
                    fontSize:"16px",
                    color:"text.blackTitle",
                    cursor:"pointer",
                    display:"flex",
                    gap:"10px",
                    "&:hover" : {
                      backgroundColor:"background.grey",
                    }
                  }}
                >
                  <img src={accountIcon} style={{height:"20px", width:"20px"}}/>
                  {languageValues?.globalMenu?.admin[actLanguage]}
                </Box>
              }
              <Box
                onClick={() => {
                  setLogOutModal(true)
                  setGlobalMenu(false)
                }}
                sx={{
                  height:"50px",
                  padding:"15px 20px",
                  lineHeight:"20px",
                  fontSize:"16px",
                  color:"text.blackTitle",
                  cursor:"pointer",
                  display:"flex",
                  gap:"10px",
                  "&:hover" : {
                    backgroundColor:"background.grey",
                  }
                }}
              >
                <img src={logOutIcon} style={{height:"20px", width:"20px"}}/>
                {languageValues?.globalMenu?.logOut[actLanguage]}
              </Box>
            </Box>
          }
        </Box>
      }
      {/* END GLOBAL MENU */ }

      {/* LOGOUT MODAL */ }
      <MyMiniModal
        isOpen={logoutModal}
        onClose={() => {
          setLogOutModal(false)
        }}
        title={t(languageValues?.areYouSure)}
        subTitle={t(languageValues?.globalMenu?.logOutSubTitle)}
        topIcon={bigLogOutIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => {
              logout(() => navigate("/"))
            }}
          >
            {languageValues?.globalMenu?.logOut[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END LOGOUT MODAL */ }

      {/* ACCOUNT MODAL */ }
      <MyModal
        isOpen={accountModal}
        maxWidth="xs"
        onClose={() => {
          setAccountModal(false)
        }}
        fullCustom
      >
        <MyAccount
          actUser={actUser}
          updateUserContext={updateUserContext}
          onCloseModal={() => {setAccountModal(false)}}
          page={myAccountPage}
          setPage={setMyAccountPage}
        />
      </MyModal>
      {/* END ACCOUNT MODAL */ }
    </>
  );
};


export default GlobalMenu;
